import styled from 'styled-components'

export const Description = styled.p``
